import React from "react";
import "./modal.css";

export default function DocumentPreviewModal({ doc, onClose }) {
  if (!doc) return null;

  const fileUrl = doc.file_url;
  const fileName = doc.original_filename || "Document Preview";
  const ext = fileName.split(".").pop()?.toLowerCase();
  
  const isImage = ["png", "jpg", "jpeg", "gif", "webp"].includes(ext);
  const isPdf = ext === "pdf";

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 9999 }}>
      <div 
        className="modal-content" 
        style={{ 
          width: "80%", 
          maxWidth: "900px", 
          height: "85vh", 
          display: "flex", 
          flexDirection: "column",
          padding: 0,
          overflow: "hidden"
        }} 
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header" style={{ padding: "15px 20px", borderBottom: "1px solid #e2e8f0", backgroundColor: "#fff" }}>
          <h3 style={{ margin: 0, fontSize: "1.1rem", color: "#1e293b" }}>{fileName}</h3>
          <button className="close-btn" onClick={onClose} style={{ border: "none", background: "none", fontSize: "1.5rem", cursor: "pointer", color: "#64748b" }}>&times;</button>
        </div>
        <div className="modal-body" style={{ flex: 1, backgroundColor: "#f8fafc", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
          {isImage ? (
            <img src={fileUrl} alt="Document Preview" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
          ) : isPdf ? (
            <iframe src={fileUrl} width="100%" height="100%" title="Document Preview" style={{ border: "none" }} />
          ) : (
            <div style={{ textAlign: "center", padding: "2rem" }}>
              <p style={{ marginBottom: "1rem", color: "#64748b" }}>Preview not available for this file type.</p>
              <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ padding: "10px 20px", background: "#3b82f6", color: "white", borderRadius: "6px", textDecoration: "none", display: "inline-block" }}>
                Download / Open
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
